import api from '.';

//pode ser uma empresa ou um array de empresas
export const gruposByEmpresaId = async (obj) => {
    try {
        const { data } = await api.post('/grupo/gruposByEmpresaId', obj);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const obterSubGrupoByGrupoId = async (id) => {
    try {
        const { data } = await api.get('grupo/obterSubGrupoByGrupoId', {
            params: { id },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
/**
 *
 * @param {*} obj { start, size, filters, filtersMode, globalFilter, sorting, grupoId }
 * @returns data
 */
export const listarSubGrupo = async ({ start, size, filters, filtersMode, globalFilter, sorting, grupoId }) => {
    if (!grupoId) {
        return [];
    }
    try {
        const { data } = await api.get('grupo/listarSubGrupo', {
            params: { start, size, filters, filtersMode, globalFilter, sorting, grupoId },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
export const subgrupo = async (obj) => api.post(`grupo/subgrupo`, obj);
